'use client';

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getImplicitPreference, themeLocalStorageKey } from './shared';
const initialContext = {
  setTheme: () => null,
  theme: undefined
};
const ThemeContext = createContext(initialContext);
export const ThemeProvider = t0 => {
  const $ = _c(9);
  const {
    children,
    defaultMode
  } = t0;
  const [theme, setThemeState] = useState(defaultMode === "onlylight" ? "light" : defaultMode === "onlydark" ? "dark" : defaultMode);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = themeToSet => {
      if (themeToSet === null) {
        window.localStorage.removeItem(themeLocalStorageKey);
        const implicitPreference = getImplicitPreference();
        document.documentElement.setAttribute("data-theme", implicitPreference || "");
        if (implicitPreference) {
          setThemeState(implicitPreference);
        }
      } else {
        setThemeState(themeToSet);
        window.localStorage.setItem(themeLocalStorageKey, themeToSet);
        document.documentElement.setAttribute("data-theme", themeToSet);
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const setTheme = t1;
  let t2;
  let t3;
  if ($[1] !== defaultMode) {
    t2 = () => {
      const themeToSet_0 = defaultMode === "onlylight" ? "light" : defaultMode === "onlydark" ? "dark" : window.localStorage.getItem(themeLocalStorageKey) || getImplicitPreference() || defaultMode;
      document.documentElement.setAttribute("data-theme", themeToSet_0);
      setThemeState(themeToSet_0);
    };
    t3 = [defaultMode];
    $[1] = defaultMode;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== theme) {
    t4 = {
      setTheme,
      theme
    };
    $[4] = theme;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== t4) {
    t5 = <ThemeContext.Provider value={t4}>{children}</ThemeContext.Provider>;
    $[6] = children;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export const useTheme = () => {
  return useContext(ThemeContext);
};